import { isArray, isEmpty } from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';

import { AdEditor } from './ad-editor';
import { AdsManager } from '../ads-management';

const AddTextStepInternal = (props) => {
  const {
    data,
    enableAdsManagment,
    wizardPerfMarker,
  } = props;

  const stepPerfMarker = useMemo(() => wizardPerfMarker.createChild('AddTextStep', { autoEnd: true }), [wizardPerfMarker]);

  // eslint-disable-next-line object-curly-newline
  const { ads, loaded } = data;

  const showAdsManagement = useMemo(() => enableAdsManagment && isArray(ads) && !isEmpty(ads), [enableAdsManagment, ads]);

  return loaded && (
    <div className="add-text-step">
      {showAdsManagement ? (
        <AdsManager
          {...props}
          stepPerfMarker={stepPerfMarker}
        />
      ) : (
        <AdEditor
          {...props}
          stepPerfMarker={stepPerfMarker}
        />
      )}
    </div>
  );
};

AddTextStepInternal.propTypes = {
  data: PropTypes.shape({
    campaignId: PropTypes.number,
    adGroupId: PropTypes.number,
    ads: PropTypes.shape({}),
    adType: PropTypes.string,
    loaded: PropTypes.bool,
  }),
  onDataChange: PropTypes.func.isRequired,
  error: PropTypes.shape({
    serverErrors: PropTypes.arrayOf(PropTypes.shape({})),
    systemErrors: PropTypes.arrayOf(PropTypes.string),
  }),
  permissions: PropTypes.shape({
    IsImpressionTrackingUrlsEnabled: PropTypes.bool,
  }).isRequired,
  serverContext: PropTypes.shape({}).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  wizardPerfMarker: PropTypes.shape({
    createChild: PropTypes.func.isRequired,
  }).isRequired,
  enableAdsManagment: PropTypes.bool,
  adTypes: PropTypes.arrayOf(PropTypes.string),
};

AddTextStepInternal.defaultProps = {
  data: {
    campaignId: -1,
    adGroupId: -1,
    ads: {},
    loaded: false,
  },
  error: null,
  enableAdsManagment: false,
  adTypes: [],
};

export const AddTextStep = withPermissions(withServerContext(withScope(AddTextStepInternal)));
